import { z } from "zod";

const reportsPersonSchema = z.object({
	prof_id: z.string(),
	full_name: z.string(),
	email: z.string(),
	prof_type: z.string().nullable(),
});

const reportsDataSchema = z.object({
	self: reportsPersonSchema.nullable(),
	managers: z.array(reportsPersonSchema),
	manages: z.array(reportsPersonSchema),
});

export type ReportsPerson = z.infer<typeof reportsPersonSchema>;
export type ReportsData = z.infer<typeof reportsDataSchema>;

export const EMPTY_REPORTS: ReportsData = {
	self: null,
	managers: [],
	manages: [],
};

export function parseReportsData(data: unknown): ReportsData {
	return reportsDataSchema.parse(data ?? EMPTY_REPORTS);
}
